import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Archive from './icon-archive.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Archive {...validProps} />;
}
SvgComponent.iconName = 'archive';

/**
 * @deprecated This is a legacy icon
 */
export const ArchiveIcon = svgIconWrapper(SvgComponent);
